module.exports = __webpack_public_path__ + "media/images/slider_4-5d4a231180d0af5edd98b8d8c630d329.png";